import { createElement } from "react";
/**
 * External dependencies
 */
import classNames from 'classnames';

/**
 * WordPress dependencies
 */
import { useAsyncList } from '@wordpress/compose';
import { __experimentalHStack as HStack, __experimentalVStack as VStack, Button, Spinner } from '@wordpress/components';
import { ENTER, SPACE } from '@wordpress/keycodes';
import { info } from '@wordpress/icons';
import { __ } from '@wordpress/i18n';
export default function ViewList({
  view,
  fields,
  data,
  isLoading,
  getItemId,
  onSelectionChange,
  onDetailsChange,
  selection,
  deferredRendering
}) {
  const shownData = useAsyncList(data, {
    step: 3
  });
  const usedData = deferredRendering ? shownData : data;
  const mediaField = fields.find(field => field.id === view.layout.mediaField);
  const primaryField = fields.find(field => field.id === view.layout.primaryField);
  const visibleFields = fields.filter(field => !view.hiddenFields.includes(field.id) && ![view.layout.primaryField, view.layout.mediaField].includes(field.id));
  const onEnter = item => event => {
    const {
      keyCode
    } = event;
    if ([ENTER, SPACE].includes(keyCode)) {
      onSelectionChange([item]);
    }
  };
  const hasData = usedData?.length;
  if (!hasData) {
    return createElement("div", {
      className: classNames({
        'dataviews-loading': isLoading,
        'dataviews-no-results': !hasData && !isLoading
      })
    }, !hasData && createElement("p", null, isLoading ? createElement(Spinner, null) : __('No results')));
  }
  return createElement("ul", {
    className: "dataviews-view-list"
  }, usedData.map(item => {
    return createElement("li", {
      key: getItemId(item),
      className: classNames({
        'is-selected': selection.includes(item.id)
      })
    }, createElement(HStack, {
      className: "dataviews-view-list__item-wrapper"
    }, createElement("div", {
      role: "button",
      tabIndex: 0,
      "aria-pressed": selection.includes(item.id),
      onKeyDown: onEnter(item),
      className: "dataviews-view-list__item",
      onClick: () => onSelectionChange([item])
    }, createElement(HStack, {
      spacing: 3,
      justify: "start",
      alignment: "flex-start"
    }, createElement("div", {
      className: "dataviews-view-list__media-wrapper"
    }, mediaField?.render({
      item
    }) || createElement("div", {
      className: "dataviews-view-list__media-placeholder"
    })), createElement(VStack, {
      spacing: 1
    }, createElement("span", {
      className: "dataviews-view-list__primary-field"
    }, primaryField?.render({
      item
    })), createElement("div", {
      className: "dataviews-view-list__fields"
    }, visibleFields.map(field => {
      return createElement("span", {
        key: field.id,
        className: "dataviews-view-list__field"
      }, field.render({
        item
      }));
    }))))), onDetailsChange && createElement(Button, {
      className: "dataviews-view-list__details-button",
      onClick: () => onDetailsChange([item]),
      icon: info,
      label: __('View details'),
      size: "compact"
    })));
  }));
}
//# sourceMappingURL=view-list.js.map